import React from "react"
import {formatTextTestIds} from "@next/utils"
import {Image} from "./component"
import {ImageProps} from "../../index"

export const StandardProductImage = ({src, alt, threeFourImageryEnabled}: ImageProps) => {
    return (
        <Image
            data-testid={formatTextTestIds("header-mini-shopping-bag-item-image")}
            src={src}
            alt={alt}
            threeFourImageryEnabled={threeFourImageryEnabled}
        />
    )
}

export default StandardProductImage
